<template>
  <span
    v-if="isIncomplete"
    class="incomplete-record-indicator"
    role="img"
    aria-label="Fiche incomplète"
    title="Fiche incomplète"
  >
    <feather-icon icon="FlagIcon" size="16" />
  </span>
</template>

<script>
export default {
  props: {
    isIncomplete: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.incomplete-record-indicator {
  display: inline-flex;
  align-items: center;
  color: #ea5455;
  vertical-align: middle;
}
</style>
